module.exports = __webpack_public_path__ + "files/ef5c3a6ec5285ac2dd5c99812f5b195b.svg";